// React
import React from 'react';

// Packages

// Utilities
import { getYears } from 'utilities';
import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsAwardDetails } from 'components/_cardContents/resultsAward/resultsAward';

const Name = CONSTANTS.RESULTS.AWARD;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Award_Type__c',
        fieldName: 'Award_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Award_Type__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsAwardDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Award_Type__c, Year__c } = formData;

        // Data for sf
        return {
            Award_Type__c,
            Year__c: Year__c?.length > 0 ? Year__c : null,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'Select',
                name: 'Year__c',
                object: object.config('Initiative_Result__c.Year__c___Award'),
                options: getYears(),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Award',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const { Award_Type__c, Year__c } = utilities.results.get(id);

    form.setValue('Award_Type__c', Award_Type__c);
    form.setValue('Year__c', Year__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
